import { makeStyles } from 'tss-react/mui';

import { ColorPalette } from '../../../../../../design/palette/colorPalette';

export default makeStyles()({
  title: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 700,
    fontFamily: "'Articulat CF', sans-serif",
    color: ColorPalette.BASTILLE,
    backgroundColor: 'transparent',
    paddingBottom: 0,
  },
  content: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 700,
    fontFamily: "'Articulat CF', sans-serif",
    color: ColorPalette.BASTILLE,
  },
  actions: {
    paddingBottom: 0,
  },
  button: {
    color: 'white',
    backgroundColor: ColorPalette.BASTILLE,
    '&:hover': {
      backgroundColor: ColorPalette.BASTILLE,
    },
  },
  buttonClose: {
    border: 'none',
    boxShadow: 'none',
    color: ColorPalette.AMARANTH,
    backgroundColor: 'transparent',
    '&:hover': {
      border: 'none',
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
});
